import React, { type PropsWithChildren } from 'react';

import { cssMap } from '@atlaskit/css';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	grid: {
		gridTemplateAreas: '"icon" "text" "cta"',
		gridTemplateColumns: 'min-content 1fr auto',
		wordBreak: 'break-word',
		borderRadius: token('radius.small'),
		backgroundColor: token('color.background.information'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		paddingTop: token('space.150'),
		paddingBottom: token('space.150'),
	},
});

export type MessageBannerGridProps = {
	testId?: string;
};

export const MessageBannerGrid = ({
	testId,
	children,
}: PropsWithChildren<MessageBannerGridProps>): React.JSX.Element => {
	return (
		<Grid alignItems="center" columnGap="space.150" testId={testId} xcss={styles.grid}>
			{children}
		</Grid>
	);
};
